module.exports = __webpack_public_path__ + "static/laptop-img-0fc6afb408f0208b853741eb7dc628fc.png";